import { GridCellProps } from '@progress/kendo-react-grid';
import { flatten } from 'lodash';
import { useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import { getBgColor, getIcon } from 'src/utils/icons';

const LineItemInfo = (props: GridCellProps) => {
  const { dataItem } = props;

  const errorMessages: string[] = useMemo(
    () =>
      dataItem?.errors?.errorMessages ||
      (dataItem?.errors ? flatten(Object?.values(dataItem?.errors)) : []),
    [dataItem?.errors]
  );

  const warningMessages: string[] = useMemo(
    () =>
      dataItem?.warnings?.warningMessages ||
      (dataItem?.warnings ? flatten(Object?.values(dataItem?.warnings)) : []),
    [dataItem.warnings]
  );

  const infos: string[] = useMemo(
    () => (dataItem?.informations ? flatten(Object?.values(dataItem?.informations)) : []),
    [dataItem.informations]
  );

  return (
    <GridCellBase
      {...props}
      disableToolTip
      className={`overflow-visible-imp ${getBgColor(errorMessages, warningMessages, infos)}  ${
        props.className
      }`}
      rowSelectionEnabled
    >
      <PopUp
        popupAlign={{ horizontal: 'center', vertical: 'bottom' }}
        anchorAlign={{ horizontal: 'right', vertical: 'top' }}
        className="max-h-[180px] !z-99999"
        content={
          <div className="m-1 max-w-[350px]">
            <PopUpContentWrapper type="Information" contents={infos as string[]} />
            <PopUpContentWrapper type="Error" contents={errorMessages as string[]} />
            <PopUpContentWrapper type="Warning" contents={warningMessages as string[]} />
          </div>
        }
      >
        <div className="flex justify-center items-center">
          {getIcon(errorMessages as string[], warningMessages as string[], infos as string[])}
        </div>
      </PopUp>
    </GridCellBase>
  );
};

export default LineItemInfo;
